var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import React, { forwardRef, useCallback, useMemo, useState } from 'react';
import { default as AntTransfer } from 'antd/lib/transfer';
import { map } from 'lodash';
export var Transfer = forwardRef(function (props, ref) {
  var renderContent = props.renderContent,
      costiomFilter = props.filterOption,
      onChange = props.onChange,
      options = props.options,
      name = props.name,
      value = props.value,
      otherProps = __rest(props, ["renderContent", "filterOption", "onChange", "options", "name", "value"]);

  var _a = useState([]),
      selectedKeys = _a[0],
      setSelectedKeys = _a[1];

  var render = useCallback(function (option) {
    return renderContent ? renderContent(option) : option.title;
  }, [renderContent]);
  var filterOption = useCallback(function (inputValue, item) {
    return costiomFilter ? costiomFilter(inputValue, item) : item.title.indexOf(inputValue) > -1;
  }, [costiomFilter]);
  var dataSource = useMemo(function () {
    return map(options, function (_a) {
      var id = _a.id,
          name = _a.name;
      return {
        key: id,
        title: name
      };
    });
  }, [options]);
  var handleChange = useCallback(function (targetKeys) {
    onChange && onChange(targetKeys, name);
  }, [name, onChange]);
  var handleSelectChange = useCallback(function (sourceSelectedKeys, targetSelectedKeys) {
    setSelectedKeys(__spreadArrays(sourceSelectedKeys, targetSelectedKeys));
  }, []);

  var Props = __assign(__assign({}, otherProps), {
    ref: ref,
    render: render,
    targetKeys: value,
    dataSource: dataSource,
    selectedKeys: selectedKeys,
    filterOption: filterOption,
    onChange: handleChange,
    onSelectChange: handleSelectChange
  });

  return React.createElement(AntTransfer, __assign({}, Props));
});